const sendHeight = () => {
  window.parent.postMessage({ iframeHeight: document.documentElement.scrollHeight }, '*');
};

window.addEventListener('resize', sendHeight);
window.addEventListener('load', sendHeight);
